import { render, staticRenderFns } from "./DetailHasilUjianPOLRI.vue?vue&type=template&id=556a21cd"
import script from "./DetailHasilUjianPOLRI.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianPOLRI.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianPOLRI.vue?vue&type=style&index=0&id=556a21cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports